export const swedish_sv = {
    name: 'swedish_sv',
    months: [
        ['januari', 'Jan'],
        ['februari', 'Feb'],
        ['mars', 'Mar'],
        ['april', 'Apr'],
        ['maj', 'Maj'],
        ['juni', 'Jun'],
        ['juli', 'Jul'],
        ['augusti', 'Aug'],
        ['september', 'Sep'],
        ['oktober', 'Okt'],
        ['november', 'Nov'],
        ['december', 'Dec'],
    ],
    weekDays: [
        ['Saturday', 'L'],
        ['Sunday', 'S'],
        ['Monday', 'M'],
        ['Tuesday', 'T'],
        ['Wednesday', 'O'],
        ['Thursday', 'T'],
        ['Friday', 'F'],
    ],
    digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
    meridiems: [
        ['AM', 'am'],
        ['PM', 'pm'],
    ],
};
